import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

const useFastCheckoutLoading = ({ userDataMapped }) => {
  const { loading: loadingCreditCard } = useSelector(state => state.creditCard);
  const { loading: loadingFastCheckout } = useSelector(state => state.fastCheckout);
  const {
    loading: loadingSummary, loadingCountries, loadingUpdateSummary, loadingZipCode,
  } = useSelector(state => state.summary);

  const calculateLoadingProgress = useCallback((...loadings) => {
    if (loadings.length === 0) return 100;

    const loadingsFinished = loadings.filter(v => !v).length;
    return Math.round((loadingsFinished / loadings.length) * 100);
  }, []);

  const isLoading = useMemo(() => (
    loadingCreditCard
    || loadingFastCheckout
    || loadingCountries
    || loadingSummary
    || loadingUpdateSummary
    || !userDataMapped
  ), [loadingCreditCard, loadingFastCheckout, loadingCountries, loadingSummary, loadingUpdateSummary, userDataMapped]);

  const loadingProgress = useMemo(() => calculateLoadingProgress(
    loadingCreditCard,
    loadingFastCheckout,
    loadingCountries,
    loadingSummary,
    loadingUpdateSummary,
    !userDataMapped,
  ), [loadingCreditCard, loadingFastCheckout, loadingCountries, loadingSummary, loadingUpdateSummary, userDataMapped, calculateLoadingProgress]);

  return {
    isLoading,
    loadingProgress,
    loadingCreditCard,
    loadingFastCheckout,
    loadingSummary,
    loadingCountries,
    loadingUpdateSummary,
    loadingZipCode,
  };
};

export default useFastCheckoutLoading;
